export default {
	'/': 'OutageMap',
	'/outageMap': 'OutageMap',
	'/*/outageMap': 'OutageMap'
}
